import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../../../_services';
import {ToastService} from '../../../../_services/toast.service';
import {TranslateService} from '@ngx-translate/core';
import {LoadingService} from '../../../../_services/loading.service';
import {Router} from '@angular/router';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  submitted = false;

  constructor(public toast: ToastService,
              public translate: TranslateService,
              private spinner: LoadingService,
              public authService: UserService,
              public router: Router) {
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl('',
        [
          Validators.required,
          Validators.email
        ])
    });
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.submitted = true;

    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      return;
    }
    const user: any = this.forgotPasswordForm.value;
    this.spinner.show();
    this.authService.forgotPassword(user)
      .pipe(first())
      .subscribe(
        (userObj) => {
          this.spinner.hide();
          this.toast.display('Please check your email to reset your password');
          this.router.navigate(['./user/auth/reset-password'], {queryParams: {email: user.email}});
        }, error => {
          this.spinner.hide();
          console.error('error', error);
          this.toast.error('Email not found');
        });
  }

  // convenience getter for easy access to form fields
  get field(): any {
    return this.forgotPasswordForm.controls;
  }

}
